import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selected, setSelected] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelected(url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="categories" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-3">
            Browse Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            Shop by Category
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Select a category below to explore products on our main store. Thousands of items across every style and budget.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10">
          <div className="relative">
            <select
              value={selected}
              onChange={handleDropdownChange}
              className="w-full appearance-none px-4 py-3 pr-10 rounded-lg border border-background-300 bg-background-50 text-foreground-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition cursor-pointer"
            >
              <option value="">— Choose a Category —</option>
              {categories.map((cat, idx) => (
                <option key={idx} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-foreground-500">
              <i className="ri-arrow-down-s-line text-lg"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <a
              key={idx}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-100/60 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 group-hover:bg-primary-200 group-hover:text-primary-700 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}